import { get } from '../utils/axios'

export const getSexsAPI = async () => {
  return await get('sexs')
}
